import { FONT_FAMILY } from "./foundations/textStyle";

export default {
  "html, body": {
    fontFamily: FONT_FAMILY.PRIMARY,
    color: "#1A202C",
  },
  "*::placeholder, *[data-placeholder]": {
    color: "#718096",
  },
};
